import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Events'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Events'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Routing'

export const mediaPlatformEventsRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.EVENTS,
  loader: () => ({
    crumb: t('entity:publishing.event', { count: 2 }),
  }),
})

export const mediaPlatformEventsLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformEventsRoute,
  id: 'mediaPlatformEventsLayout',
  component: Structure,
})

type MediaPlatformEventsOverviewSearch = {
  query?: string
}

export const mediaPlatformEventsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformEventsLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformEventsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
